<template>
  <main class="p-5">
    <div class="container">
      <div class="row">
        <div class="col-12 m-0 no-max-w home-div d-flex justify-content-center">
          <div class="p-4 w-50">
            <label class="fw-bold">Temizleme Türü Seçin:</label>
            <div class="d-flex gap-3 my-3">
              <div>
                <input type="checkbox" id="usePath" v-model="usePath" class="me-2">
                <label for="usePath">Path</label>
              </div>
              <div>
                <input type="checkbox" id="useUserId" v-model="useUserId" class="me-2">
                <label for="useUserId">User ID</label>
              </div>
            </div>

            <div v-if="usePath">
              <label for="pathSelect">Path Seçin:</label>
              <select id="pathSelect" v-model="selectedPath" class="border p-2 rounded w-full mt-2">
                <option disabled value="">Bir path seçin</option>
                <option v-for="item in paths" :key="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>

            <div class="mt-3" v-if="useUserId">
              <label for="userIdInput">User ID Girin:</label>
              <input
                  id="userIdInput"
                  type="text"
                  :value="userId"
                  @input="handleUserIdInput"
                  placeholder="Örn: 123456"
                  class="border p-2 rounded w-full mt-2 ms-2"
              />
            </div>

            <Button
                class="mt-4"
                label="Cache Temizle"
                @click="submitPath"
                :disabled="!isValidSelection"
            />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Swal from 'sweetalert2'

export default {
  name: 'CacheCleaner',

  data() {
    return {
      paths: [
        'discover',
        'chakra',
        'daily-affirmation',
        'celestial-guidence-section',
        'biorythm',
        'daily',
        'biorythm-bar',
        'basic-planets',
        'birth-chart',
        'stories',
        'v2-calendar',
        'transit-long-short-v4',
        'transit-long-term'
      ],
      selectedPath: '',
      userId: '',
      usePath: false,
      useUserId: false
    }
  },

  computed: {
    isValidSelection() {
      const pathOK = this.usePath ? !!this.selectedPath : true
      const userOK = this.useUserId ? !!this.userId.trim() : true
      return (this.usePath || this.useUserId) && pathOK && userOK
    }
  },

  methods: {
    async submitPath() {
      let finalPath = ''
      if (this.useUserId && this.usePath) {
        finalPath = `${this.userId}-${this.selectedPath}`
      } else if (this.useUserId) {
        finalPath = this.userId
      } else if (this.usePath) {
        finalPath = this.selectedPath
      }

      try {
        await this.$appAxios.get(`/admin/content/cache-clean/${finalPath}`)
        Swal.fire({
          icon: 'success',
          title: 'Başarılı!',
          text: `Cache temizlendi: ${finalPath}`,
          confirmButtonText: 'Tamam'
        })
      }catch (error) {
        const errorMessage = error?.response?.data || 'Bir hata oluştu'

        Swal.fire({
          icon: 'error',
          title: 'Hata!',
          text: errorMessage,
          confirmButtonText: 'Kapat'
        })
      }
    },
    handleUserIdInput(event) {
      this.userId = event.target.value.trim()
    }
  }
}
</script>
